import { render, staticRenderFns } from "./EditorsTabsView.vue?vue&type=template&id=692412df"
import script from "./EditorsTabsView.vue?vue&type=script&lang=js"
export * from "./EditorsTabsView.vue?vue&type=script&lang=js"
import style0 from "./EditorsTabsView.vue?vue&type=style&index=0&id=692412df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports